module.exports = __webpack_public_path__ + "img/huidawenti@2x.f3ef790f.png";